import React, { useState, useMemo, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReportsFromAPI, downloadExcelReport } from '../Redux/IntegrationDucks';
import { Paper, Box, TextField, Button, CircularProgress } from '@mui/material';
import Skeleton from '../components/Skeleton';
import { set } from 'react-hook-form';

const columns = [
  { name: 'phone', selector: row => row.phone, sortable: true },
  { name: 'name', selector: row => row.name, sortable: true },
  { name: 'dia_creacion', selector: row => row.dia_creacion, sortable: true },
  { name: 'hora_creacion', selector: row => row.hora_creacion, sortable: true },
  { name: 'phone_contacto', selector: row => row.phone_contacto, sortable: true },
  { name: 'dia_cierre', selector: row => row.dia_cierre, sortable: true },
  { name: 'hora_cierre', selector: row => row.hora_cierre, sortable: true },
  { name: 'id_Hubspot', selector: row => row.id_Hubspot, sortable: true },
  { name: 'admisibilidad', selector: row => row.admisibilidad, sortable: true },
  { name: 'Nombre', selector: row => `${row.nombre} ${row.apellido}`, sortable: true },
  { name: 'RUT', selector: row => row.rut, sortable: true },
  { name: 'Email', selector: row => row.mail },
  { name: 'Área Legal', selector: row => row.area_legal },
  { name: 'Estado', selector: row => row.estado },
  { name: 'Resumen', selector: row => row.resumen_conversacion, grow: 3 },
  { name: 'origen_wots', selector: row => row.origen_wots },
  { name: 'origen_web_wots ', selector: row => row.origen_web_wots },
  { name: 'origen_campana_wots', selector: row => row.origen_campana_wots },
  { name: 'origen_grupo_anuncio_wots', selector: row => row.origen_grupo_anuncio_wots }
];

const IntegrationReportPage = () => {
  const dispatch = useDispatch();
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const Datos = useSelector((state) => state.report.ReportList);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setFechaInicio(today);
    setFechaFin(today);
  }, []);

  useEffect(() => {
    if (Array.isArray(Datos) && Datos.length > 0) {
      setFilteredData(Datos);
      setBusquedaRealizada(false);
    }
  }, [Datos]);

  const handleFechaInicioChange = (e) => {
    setFechaInicio(e.target.value);
  };

  const handleFechaFinChange = (e) => {
    setFechaFin(e.target.value);
  };

  const handleBuscar = () => {
    setBusquedaRealizada(true);
    dispatch(fetchReportsFromAPI(fechaInicio,fechaFin));
 
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap',
          mb: 2,
          gap: 2
        }}
      >
        {/* Calendarios alineados a la izquierda */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="Desde"
            type="date"
            value={fechaInicio}
            onChange={handleFechaInicioChange}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
          <TextField
            label="Hasta"
            type="date"
            value={fechaFin}
            onChange={handleFechaFinChange}
            InputLabelProps={{ shrink: true }}
            size="small"
          />
        </Box>

        {/* Botones alineados a la derecha */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleBuscar()}
          >
            Buscar
          </Button>

          <Button
            variant="contained"
            color="success"
            disabled={loadingExcel || busquedaRealizada}
            onClick={async () => {
              setLoadingExcel(true);
              await new Promise(resolve => setTimeout(resolve, 300));
              await dispatch(downloadExcelReport(fechaInicio, fechaFin));
              setLoadingExcel(false);
            }}
            startIcon={loadingExcel ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {loadingExcel ? "Generando..." : "Descargar Excel"}
          </Button>
        </Box>
      </Box>
    );
  }, [fechaInicio, fechaFin, dispatch, loadingExcel, busquedaRealizada]);

  const customStyles = {
    table: { style: { minWidth: '100%' } },
    headRow: { style: { backgroundColor: '#F2F2F7', borderBottom: 'none' } },
    headCells: {
      style: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#86868B',
        textTransform: 'uppercase',
      },
    },
    cells: {
      style: {
        fontSize: '14px',
        color: '#1D1D1F',
      },
    },
  };

  const CustomLoader = () => (
        <div style={{ padding: '24px', width: '100%' }}>
          {Array.from({ length: 10 }).map((_, idx) => (
            <React.Fragment key={idx}>
              <Skeleton width='100%' height='2rem' />
              <br />
            </React.Fragment>
          ))}
        </div>
      );

  return (
    <div className="apple-container">
      <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressComponent={<CustomLoader />}
          progressPending={busquedaRealizada}
          persistTableHead
          customStyles={customStyles}
        />
      </Paper>
    </div>
  );
};

export default IntegrationReportPage;